var map = {
	"./01_get_account_apiRestrictions.json": "l5cf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hR1o";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/common/api/permission \.json$
// module id = hR1o
// module chunks = 3